import { DocumentType } from '@tcs/client-portal-api/platform_generated';
import { Document } from '@tcs/client-portal-api/types/Documents';
import Table from '@tcs/client-portal-common/components/molecules/Table';
import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import DownloadCell from '@tcs/client-portal-common/components/molecules/Table/cells/DownloadCell';
import BaseHeader from '@tcs/client-portal-common/components/molecules/Table/cells/headers/BaseHeader';
import QuarterCell from '@tcs/client-portal-common/components/molecules/Table/cells/QuarterCell';
import { getConfig } from '@tcs/client-portal/config/configService';

export interface Props {
  documents?: Document[];
  selectedAccount?: string;
  loading?: boolean;
}

export const StatementDetails = ({
  documents,
  selectedAccount,
  loading,
}: Props) => {
  const columns = [
    {
      accessor: 'date',
      header: () => <BaseHeader text="Date" />,
      cell: (info) => <QuarterCell value={info.getValue()} />,
      size: 250,
    },
    {
      accessor: 'fileName',
      header: () => <BaseHeader text="Document" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 300,
    },
    {
      accessor: 'downloadPath',
      header: () => <BaseHeader text="PDF" />,
      cell: (info) => {
        const url = `${
          getConfig().API_BASE_URL
        }/documents/account/${selectedAccount}/${info.row.original.year}/${
          info.row.original.fileId
        }?type=${DocumentType.STATEMENT}`;

        return (
          <DownloadCell url={url} fileName={info.row.original.documentType} />
        );
      },
      size: 150,
    },
  ];

  return <Table columns={columns} data={documents} loading={loading} />;
};

export default StatementDetails;
